import { render, staticRenderFns } from "./SuppliesClassRegistrationPopup.vue?vue&type=template&id=159a5fde&scoped=true&"
import script from "./SuppliesClassRegistrationPopup.vue?vue&type=script&lang=js&"
export * from "./SuppliesClassRegistrationPopup.vue?vue&type=script&lang=js&"
import style0 from "./SuppliesClassRegistrationPopup.vue?vue&type=style&index=0&id=159a5fde&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "159a5fde",
  null
  
)

export default component.exports